import { inject, ElementRef } from '@angular/core';
import { ModalRef } from '../../modal-ref';
import { ModalService } from '../../modal.service';

export abstract class ModalCloseBase  {

  protected modalRef: ModalRef<unknown>;
  protected elementRef = inject(ElementRef);
  protected modalService = inject(ModalService);

  close(reason: string): void {
    let modalRef = this.modalRef;

    if (modalRef == null) {
      modalRef = this.getParentModal();
    }
    if (modalRef === undefined) {
      throw new Error('Button is not located inside modal.');
    }
    modalRef.handleClose(reason);
  }

  getParentModal(): ModalRef<unknown> {
    let parent: HTMLElement | null = this.elementRef.nativeElement.parentElement;

    while (parent !== null && !parent.classList.contains('td-wb-modal')) {
      parent = parent.parentElement;
    }
    if (parent !== null) {
      return this.modalService.openModals.find((modal: ModalRef<unknown>): boolean => modal.id === parent.id);
    }
  }
}
